module.exports = __webpack_public_path__ + "static/media/attach-off.4a56519e.svg";